import { ChatAttachment } from './ChatAttachment'
import { User } from '../models/User'
import { StringUtils } from '../utils/StringUtils'
import { Team } from '../models/Team'
import { Http } from '../utils/Http'

export class ChatMessage {
  public id: number|null = null;
  public uuid: string|null = null;
  public user: User|null = null;
  public content: string|null = null;
  public rallyRoundId: number|null = null;
  public important = false;
  public attachments: ChatAttachment[] = [];
  public gameId: number|null = null;
  public createdAt = '';
  public team: Team|null = null;
  public game: string|null = null;
  public points = 0
  public uploaded = false
  public otherPostRated = false;
  public otherPostPoints = 0;
  public customPosterId = 0;
  public deletedAt: string|null = null

  constructor () {
    this.uuid = StringUtils.generateUUID()
  }

  static async delete (id: number) {
    return await Http.request(`/api/post/${id}`, {
      method: 'DELETE'
    })
  }

  static async changeChallenge (postId: number, challengeId: number) {
    return await Http.request(`/api/post/${postId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ gameId: challengeId })
    })
  }
}
